/**
 * 立项调研组件
 * 用于产品开发前期的市场调研、竞品分析和可行性评估
 * 
 * 重构后结构:
 * - 业务逻辑: useProjectResearch.ts
 * - 常量配置: constants.ts
 * - 子组件: *Card.tsx
 */

import React from 'react';
import { Form, Space, Button, FormInstance } from 'antd';
import { SaveOutlined, FileSearchOutlined } from '@ant-design/icons';

// 子组件
import { MarketResearchCard } from './MarketResearchCard';
import { CompetitorAnalysisCard } from './CompetitorAnalysisCard';
import { TargetUserCard } from './TargetUserCard';
import { ProductPositioningCard } from './ProductPositioningCard';
import { FeasibilityCard } from './FeasibilityCard';
import { InvestmentROICard } from './InvestmentROICard';
import { DecisionCard } from './DecisionCard';

// Hook
import { useProjectResearch } from './useProjectResearch';

interface ProjectResearchProps {
    skuId?: number;
    form: FormInstance;
}

export const ProjectResearch: React.FC<ProjectResearchProps> = ({ skuId, form }) => {
    const {
        competitors,
        painPoints,
        addCompetitor,
        removeCompetitor,
        updateCompetitor,
        addPainPoint,
        removePainPoint,
        updatePainPoint,
        handleSave,
    } = useProjectResearch({ skuId, form });

    return (
        <div style={{ padding: '24px' }}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {/* 页面标题 */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h2 style={{ margin: 0 }}>
                            <FileSearchOutlined style={{ marginRight: 8 }} />
                            立项调研
                        </h2>
                        <p style={{ color: '#666', marginTop: 8 }}>
                            产品开发前期的市场调研、竞品分析和可行性评估
                        </p>
                    </div>
                    <Button type="primary" icon={<SaveOutlined />} onClick={handleSave}>
                        保存调研数据
                    </Button>
                </div>

                <Form form={form} layout="vertical">
                    {/* 市场调研 */}
                    <MarketResearchCard />

                    {/* 竞品分析 */}
                    <CompetitorAnalysisCard
                        competitors={competitors}
                        onAdd={addCompetitor}
                        onRemove={removeCompetitor}
                        onUpdate={updateCompetitor}
                    />

                    {/* 目标用户 */}
                    <TargetUserCard
                        painPoints={painPoints}
                        onAddPainPoint={addPainPoint}
                        onRemovePainPoint={removePainPoint}
                        onUpdatePainPoint={updatePainPoint}
                    />

                    {/* 产品定位 */}
                    <ProductPositioningCard />

                    {/* 可行性评估 */}
                    <FeasibilityCard />

                    {/* 投资回报预期 */}
                    <InvestmentROICard />

                    {/* 决策建议 */}
                    <DecisionCard />
                </Form>
            </Space>
        </div>
    );
};

export default ProjectResearch;
